const { REACT_APP_BUCKET_S3_RESOURCES } = process.env;

function getDeliveryLogo(systemName) {
  return `${REACT_APP_BUCKET_S3_RESOURCES}/logos/deliveries/${systemName}/main.png`;
}
export default getDeliveryLogo;
